<div class="footer flex flex-wrap panel border-t">
    <div class="w-full sm:w-1/2 p-3 flex flex-row justify-center sm:justify-start items-center gap-5">
        
        <span class="text-muted">
            Copyright <i class="fa-solid fa-copyright"></i> {{currentYear}}, groupworkguru.com
        </span>
        
        <span class="text-muted">
            ABN 98 252 195 833
        </span>
    </div>

    <div class="w-full sm:w-1/2 p-3 flex flex-row justify-center sm:justify-end items-center gap-5">
        
        <a href="https://docs.groupworkguru.com/privacy" target="_blank">Privacy Statement</a>
    
        <a href="https://docs.groupworkguru.com/terms" target="_blank">Terms of Use</a>
    
        <a href="mailto:hello@groupworkguru.com" target="_blank">Contact us</a>
    </div>
</div>
